import Cookies from 'js-cookie';

class EventsNav {

  constructor() {
    this.defaultCountry = 'ES';

    // Nav Anchor Tags
    this.eventAnchors = Array.from(document.querySelectorAll('ul.countries_nav_events > li > a[data-iso]'));

    // Hero Section Sections
    this.heroSections = Array.from(document.querySelectorAll('[data-hero-country]'));
    //console.log(this.heroSections);

    // Event Cards
    this.eventCards = Array.from(document.querySelectorAll('[data-event-card]'));
    //console.log(this.eventCards);

    // Event Page Navigation
    this.menuContainer;
    if (document.querySelector('.menu-countries-container')) {
      this.menuContainer = document.querySelector('.menu-countries-container');
    } else if (document.querySelector('.menu-countries-spanish-container')) {
      this.menuContainer = document.querySelector('.menu-countries-spanish-container');
    }

    // Create Buttons
    this.createButtons(this.menuContainer);

    // Click Events
    this.clickEvents(this.eventAnchors, this.heroSections, this.eventCards);

    // Current Country
    this.currentCountry(this.eventAnchors);

    // Show Defaults
    this.showDefaults(this.eventAnchors, this.heroSections, this.eventCards);

    // Navigation Interations
    this.navInteractions();

    // Felipe's Dropdown Tags
    // this.dropdownItems = Array.from(document.querySelectorAll('[data-dropdown-value]'));
    // console.log(this.dropdownItems);

    // // CLick Events from Felipes
    // this.clickEvents(this.dropdownItems, this.heroSections, this.eventCards);
  }

  clickEvents(anchors, heroSections, cards) {

    anchors.forEach(function (country) {

      country.addEventListener('click', (event) => {
        event.preventDefault();
        // Filter for the current Country clicked
        for (let i = 0; i < anchors.length; i++) {

          if (anchors[i].classList.contains('active')) {
            anchors[i].classList.remove('active');
            anchors[i].parentNode.classList.remove('active');
          }

        }

        country.parentNode.classList.add('active');
        country.classList.add('active');

        let targetCountry = country.dataset.iso;
        Cookies.set('selectedCountry', targetCountry);
        // console.log(targetCountry);

        // Filter for the current Hero Section
        heroSections.forEach(function (sectionEL) {
          let section = sectionEL.dataset.heroCountry;

          if (section === targetCountry) {
            //console.log(sectionEL);
            sectionEL.classList.remove('hide');
          } else {
            sectionEL.classList.add('hide');
          }

        });

        // Filter for Event Cards

        cards.forEach(function (cardEl) {

          let cardSection = cardEl.dataset.eventCard;

          if (cardSection === targetCountry) {
            cardEl.classList.remove('hide');
          } else {
            cardEl.classList.add('hide');
          }

        });

      });

    });
  }

  showDefaults(anchors, heroSections, cards) {

    anchors.forEach(function (country) {

      if (country.classList.contains('active')) {

        let targetCountry = country.dataset.iso;
        //console.log(targetCountry);

        // Filter for Hero Section
        heroSections.forEach(function (sectionEL) {
          let section = sectionEL.dataset.heroCountry;

          if (section === targetCountry) {
            //console.log(sectionEL);
            sectionEL.classList.remove('hide');
          } else {
            sectionEL.classList.add('hide');
          }

        });

        // Filter for Event Cards
        cards.forEach(function (cardEl) {
          let cardSection = cardEl.dataset.eventCard;
          if (cardSection === targetCountry) {
            cardEl.classList.remove('hide');
          } else {
            cardEl.classList.add('hide');
          }
        });
      }
    });
  }

  currentCountry(anchors) {
    var _self = this;

    if ("undefined" !== typeof geolocation_url) {
      // AJAX request for current location
      let xhttp = new XMLHttpRequest();

      var current_country = Cookies.get('selectedCountry');

      if ("undefined" == typeof current_country) {
        //xhttp.open('GET', '/bbva-components/utils/info')
        xhttp.open('GET', geolocation_url);

        xhttp.onload = function () {

          if (xhttp.status === 200) {
            //Cookies.set('selectedCountry', JSON.parse(xhttp.responseText).data.country);
            current_country = is_dev ? JSON.parse(xhttp.responseText).countryCode : JSON.parse(xhttp.responseText).data.country;
            Cookies.set('selectedCountry', current_country);

            anchors.forEach(function (country) {
              if (country.dataset.iso === current_country) {
                //console.log(country);
                country.click();
                //country.classList.add('active');
              }
            });
          } else {
            // Set Argentina by default if request fails
            anchors.forEach(function (country) {
              //console.log(country.dataset.iso);
              if ( country.dataset.iso === _self.defaultCountry ) {
                country.classList.add('active');
                country.parentNode.classList.add('active');
              }
            });
          }

        }

        //xhttp.send(JSON.stringify({ project: "j95bw15y" }));
        var params = is_dev ? {
          fields: "countryCode"
        } : {
          project: "j95bw15y"
        };
        xhttp.send(JSON.stringify(params));
      } else {
        var BreakException = {};
        try {
          anchors.forEach(function (country) {
            if (country.dataset.iso === current_country) {
              //console.log(country);
              country.click();
              throw BreakException;
              //country.classList.add('active');
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        }
      }
    } else {
      // Set Argentina by default if request fails
      anchors.forEach(function (country) {
        //console.log(country.dataset.iso);
        if ( country.dataset.iso === _self.defaultCountry ) {
          country.classList.add('active');
          country.parentNode.classList.add('active');
        }
      });
    }
  }

  createButtons(menu) {

    let leftBtn = document.createElement("button");
    let rightBtn = document.createElement("button");

    if (menu) {
      if (menu.children[0].classList.contains('countries_nav-home')) {

        menu.appendChild(leftBtn).classList.add('left-btn-home');
        menu.appendChild(rightBtn).classList.add('right-btn-home');

      }

      if (menu.children[0].classList.contains('events')) {

        menu.appendChild(leftBtn).classList.add(['left-btn'], ['ui-simple-left']);
        menu.appendChild(rightBtn).classList.add(['right-btn'], ['ui-simple-right']);

      } else {
        return false;
      }
    }

  }

  navInteractions() {

    // Nav Buttons
    let leftArrow = document.querySelector('.left-btn');
    let rightArrow = document.querySelector('.right-btn');

    // Nav
    let nav;

    if (document.querySelector('ul.countries_nav_events')) {
      nav = document.querySelector('ul.countries_nav_events');
    } else if (document.querySelector('ul.countries_nav-home')) {
      nav = document.querySelector('ul.countries_nav-home');
    } else if (document.querySelector('ul.countries_nav')) {
      nav = document.querySelector('ul.countries_nav');
    }
    // ul.countries_nav_events

    this.navClickEvents(leftArrow, rightArrow, nav);

  }

  navClickEvents(leftArrow, rightArrow, nav) {

    if (leftArrow) {

      leftArrow.addEventListener('click', function () {

        // Get Dimensions
        let totalWidth = nav.clientWidth;
        let moveDistance = Math.floor((totalWidth / 1.3));

        // Move Nav
        nav.scrollLeft -= moveDistance;

      });

    }

    if (rightArrow) {

      rightArrow.addEventListener('click', function () {

        // Get Dimensions
        let totalWidth = nav.clientWidth;
        let moveDistance = Math.floor((totalWidth / 1.3));

        // Move Nav
        nav.scrollLeft += moveDistance;


      });

    }


  }


}

export default EventsNav
